<template>
  <div v-if="notification" class="w-auto h-auto bg-white fixed right-3 top-14 border-2 max-w-xl dark:bg-slate-900 shadow-md dark:shadow-md-gray-800 rounded-md py-5 px-6 z-50">
    <p v-if="messages.type == 'success'" class="text-slate-400 flex items-center">
      <span class="mr-3">
        <svg width="40px" height="40px" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M341 67C148.339 290.671 183.5 343.046 131 205.023" stroke="#000000" stroke-opacity="0.9" stroke-width="16" stroke-linecap="round" />
          <path d="M126.678 74.6892C175.762 40.3656 223.672 30.3765 275.706 57.7602C415.664 131.409 354.622 382.384 180.329 356.983C85.4278 343.149 -9.51278 223.621 90.9151 117.034" stroke="#000000" stroke-opacity="0.9" stroke-width="16" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </span>

      {{ messages.message }}
    </p>
    <p v-else class="text-red-500 flex items-center">
      <span class="mr-3">
        <svg fill="#FF0000" height="40px" width="40px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 501.481 501.481" xml:space="preserve">
          <g>
            <g>
              <path
                d="M498.281,468.34L270.014,11.807c-4.267-7.467-10.667-11.733-19.2-11.733s-16,4.267-19.2,11.733L2.281,471.541
                                                        			c-3.2,6.4-3.2,13.867,1.067,20.267c4.267,5.333,10.667,9.6,18.133,9.6h458.667c11.733,0,21.333-9.6,21.333-21.333
                                                        			C501.48,475.807,500.414,471.541,498.281,468.34z M54.547,459.807L250.814,67.274l195.2,392.533H54.547z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M250.814,182.474c-11.733,0-21.333,9.6-21.333,21.333v110.933c0,11.733,9.6,21.333,21.333,21.333
                                                        			s20.267-9.6,21.333-21.333V203.807C272.147,192.074,262.547,182.474,250.814,182.474z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M250.814,369.141c-11.733,0-21.333,9.6-21.333,21.333v7.467c0,11.733,9.6,21.333,21.333,21.333s20.267-9.6,21.333-21.333
                                                        			v-7.467C272.147,378.741,262.547,369.141,250.814,369.141z"
              />
            </g>
          </g>
        </svg>
      </span>
      {{ messages.message }}
    </p>

    <div class="cookie-popup-actions text-right">
      <button @click="hideBanner" class="absolute border-none bg-none p-0 cursor-pointer font-semibold top-2 right-2"><i class="uil uil-times text-dark dark:text-slate-200 text-2xl"></i></button>
    </div>
  </div>

  <div v-if="chargement" :style="{ height: scrollHeight + 'px' }" class="absolute w-full bgBlack z-50 flex flex-col items-center justify-center">
    <!-- <div class="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12 mb-4"></div> -->
    <div>
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block" width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
        <circle cx="75" cy="50" fill="#dcfff8" r="5">
          <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.9166666666666666s"></animate>
          <animate attributeName="fill" values="#dcfff8;#dcfff8;#00e2ff;#dcfff8;#dcfff8" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.9166666666666666s"></animate>
        </circle>
        <circle cx="71.65063509461098" cy="62.5" fill="#dcfff8" r="5">
          <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.8333333333333334s"></animate>
          <animate attributeName="fill" values="#dcfff8;#dcfff8;#00e2ff;#dcfff8;#dcfff8" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.8333333333333334s"></animate>
        </circle>
        <circle cx="62.5" cy="71.65063509461096" fill="#dcfff8" r="5">
          <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.75s"></animate>
          <animate attributeName="fill" values="#dcfff8;#dcfff8;#00e2ff;#dcfff8;#dcfff8" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.75s"></animate>
        </circle>
        <circle cx="50" cy="75" fill="#dcfff8" r="5">
          <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.6666666666666666s"></animate>
          <animate attributeName="fill" values="#dcfff8;#dcfff8;#00e2ff;#dcfff8;#dcfff8" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.6666666666666666s"></animate>
        </circle>
        <circle cx="37.50000000000001" cy="71.65063509461098" fill="#dcfff8" r="5">
          <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.5833333333333334s"></animate>
          <animate attributeName="fill" values="#dcfff8;#dcfff8;#00e2ff;#dcfff8;#dcfff8" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.5833333333333334s"></animate>
        </circle>
        <circle cx="28.34936490538903" cy="62.5" fill="#dcfff8" r="5">
          <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.5s"></animate>
          <animate attributeName="fill" values="#dcfff8;#dcfff8;#00e2ff;#dcfff8;#dcfff8" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.5s"></animate>
        </circle>
        <circle cx="25" cy="50" fill="#dcfff8" r="5">
          <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.4166666666666667s"></animate>
          <animate attributeName="fill" values="#dcfff8;#dcfff8;#00e2ff;#dcfff8;#dcfff8" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.4166666666666667s"></animate>
        </circle>
        <circle cx="28.34936490538903" cy="37.50000000000001" fill="#dcfff8" r="5">
          <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.3333333333333333s"></animate>
          <animate attributeName="fill" values="#dcfff8;#dcfff8;#00e2ff;#dcfff8;#dcfff8" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.3333333333333333s"></animate>
        </circle>
        <circle cx="37.499999999999986" cy="28.34936490538904" fill="#dcfff8" r="5">
          <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.25s"></animate>
          <animate attributeName="fill" values="#dcfff8;#dcfff8;#00e2ff;#dcfff8;#dcfff8" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.25s"></animate>
        </circle>
        <circle cx="49.99999999999999" cy="25" fill="#dcfff8" r="5">
          <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.16666666666666666s"></animate>
          <animate attributeName="fill" values="#dcfff8;#dcfff8;#00e2ff;#dcfff8;#dcfff8" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.16666666666666666s"></animate>
        </circle>
        <circle cx="62.5" cy="28.349364905389034" fill="#dcfff8" r="5">
          <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.08333333333333333s"></animate>
          <animate attributeName="fill" values="#dcfff8;#dcfff8;#00e2ff;#dcfff8;#dcfff8" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.08333333333333333s"></animate>
        </circle>
        <circle cx="71.65063509461096" cy="37.499999999999986" fill="#dcfff8" r="5">
          <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="0s"></animate>
          <animate attributeName="fill" values="#dcfff8;#dcfff8;#00e2ff;#dcfff8;#dcfff8" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="0s"></animate>
        </circle>
      </svg>
    </div>

    <h2 class="text-center text-red-500 text-xl font-semibold">Chargement en cours...</h2>
    <p class="w-1/3 text-center text-red-500">Vérifier votre téléphone pour confirmer le payement.</p>
  </div>
  <div class="container mt-24">
    <div class="rounded-md shadow dark:shadow-gray-800 bg-white dark:bg-slate-900">
      <div class="p-6 md:flex justify-between items-center border-b border-gray-100 dark:border-gray-700">
        <div class="mb-4 md:mb-0">
          <h5 class="text-2xl font-bold uppercase">Commande !!!</h5>
        </div>
        <div class="">
          <button class="btn bg-bsd-700 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md mr-2">
            Grille tarifaire sélectionnée :
            <span class="font-bold text-lg">
              {{ grille.type }}
              <!-- / {{ periodPlan }} {{ Monthy.month  }}-->
            </span>
          </button>
        </div>
      </div>

      <div class="p-6">
        <h5 class="text-2xl font-bold">Vous y êtes presque ! Complétez votre commande</h5>
      </div>
    </div>

    <!-- choix du pack -->
    <div v-if="detailGrille" class="rounded-md shadow dark:shadow-gray-800 bg-white dark:bg-slate-900 mt-16">
      <div class="p-6 md:flex justify-between items-center border-b border-gray-100 dark:border-gray-700">
        <div class="mb-4 md:mb-0">
          <h5 class="text-xl md:text-3xl font-bold uppercase">1.Détail de la grille !!!</h5>
        </div>
      </div>
      <div class="p-6">
        <div class="relative grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-[30px]">
          <grille-pack-card-component />
        </div>
      </div>
    </div>

    <!-- compte - création -->
    <div v-if="afficherInfoPersonnel" class="rounded-md shadow dark:shadow-gray-800 bg-white dark:bg-slate-900 mt-16">
      <div class="p-6 md:flex justify-between items-center border-b border-gray-100 dark:border-gray-700">
        <div class="mb-4 md:mb-0">
          <h5 class="text-xl md:text-3xl font-bold uppercase">2.informations personnels</h5>
        </div>
      </div>
      <div class="p-6">
        <div class="relative grid grid-cols-1 xl:grid-cols-2 _gap-[30px]">
          <p>Vous avez déjà un compte ? <button class="btn btn-link text-bsd-700 after:bg-indigo-600 duration-500 ease-in-out">S'identifier</button></p>
          <div class="flex flex-col formulaire space-x-2 w-full">
            <div class="w-full md:w-1/2 mr-2 space-y-2">
              <div class="form-icon relative mt-2">
                <label for="nom" class="mb-2">Nom</label>
                <div class="form-icon relative mt-2">
                  <i class="uil uil-postcard w-4 h-4 absolute top-2 left-4"></i>
                  <input name="nom" id="nom" v-model="formulaire.nom" type="text" class="form-input pl-11" placeholder="Nom :" />
                </div>
              </div>

              <div class="form-icon relative mt-2">
                <label for="nom" class="mb-2">Email</label>
                <div class="form-icon relative mt-2">
                  <i class="uil uil-envelope w-4 h-4 absolute top-2 left-4"></i>
                  <input name="email" id="email" v-model="formulaire.email" type="email" class="form-input pl-11" placeholder="Email :" />
                </div>
              </div>

              <div class="form-icon relative mt-2">
                <label for="nom" class="mb-2">Nom de votre entreprise</label>
                <div class="form-icon relative mt-2">
                  <i class="uil uil-postcard w-4 h-4 absolute top-2 left-4"></i>
                  <input name="entrepriseName" id="entrepriseName" v-model="formulaire.entrepriseNom" type="text" class="form-input pl-11" placeholder="Nom de votre entreprise :" />
                </div>
              </div>

              <div class="form-icon relative mt-2">
                <label for="nom" class="mb-2">Pays</label>
                <div class="form-icon relative mt-2">
                  <svg class="w-4 h-4 absolute top-2 left-4" fill="#000000" width="800px" height="800px" viewBox="0 0 512 512" version="1.1" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="_x36_40_x2C__Country_x2C__flag_x2C__usa">
                      <g>
                        <g>
                          <g>
                            <g>
                              <g>
                                <path d="M89.053,388.314c-4.773,0-8.998-3.43-9.841-8.293c-0.944-5.441,2.702-10.618,8.144-11.562        c30.574-5.304,40.438-26.399,52.926-53.106c14.229-30.431,31.938-68.302,86.846-87.881c5.203-1.855,10.923,0.859,12.777,6.061        c1.855,5.202-0.858,10.923-6.061,12.777c-47.044,16.775-61.483,47.653-75.446,77.515        c-13.162,28.147-26.771,57.253-67.625,64.34C90.195,388.266,89.62,388.314,89.053,388.314z" />
                              </g>

                              <g>
                                <path d="M67.741,367.002c-4.773,0-8.998-3.429-9.841-8.293c-0.944-5.441,2.702-10.618,8.144-11.562        c30.573-5.304,40.437-26.398,52.925-53.105c14.229-30.431,31.938-68.303,86.847-87.881c5.202-1.857,10.923,0.858,12.777,6.061        c1.855,5.202-0.858,10.923-6.061,12.777c-47.044,16.775-61.483,47.653-75.446,77.514        c-13.162,28.147-26.771,57.254-67.625,64.34C68.884,366.953,68.308,367.002,67.741,367.002z" />
                              </g>

                              <g>
                                <path d="M46.527,345.789c-4.773,0-8.998-3.43-9.841-8.293c-0.944-5.441,2.702-10.618,8.144-11.562        c30.574-5.304,40.438-26.399,52.926-53.107c0.878-1.879,1.764-3.771,2.663-5.674c2.36-4.993,8.32-7.129,13.315-4.766        c4.993,2.36,7.126,8.321,4.766,13.314c-0.887,1.877-1.76,3.743-2.626,5.597c-13.162,28.147-26.772,57.254-67.625,64.341        C47.67,345.74,47.095,345.789,46.527,345.789z" />
                              </g>

                              <g>
                                <path d="M111.041,410.289c-2.629,0-5.179-1.037-7.07-2.929l-85.715-85.715c-2.641-2.641-3.59-6.532-2.462-10.092        c1.128-3.56,4.145-6.194,7.824-6.832c30.573-5.304,40.438-26.399,52.926-53.106c14.229-30.431,31.938-68.302,86.846-87.881        c3.635-1.297,7.698-0.384,10.43,2.348l86.622,86.622c2.425,2.425,3.438,5.923,2.685,9.268s-3.168,6.071-6.397,7.223        c-47.063,16.782-61.744,47.424-75.94,77.058c-13.381,27.93-27.217,56.81-68.038,63.891        C112.181,410.24,111.608,410.289,111.041,410.289z M44.421,319.527l69.871,69.87c26.833-6.645,36.454-26.73,48.459-51.788        c13.112-27.368,29.135-60.809,72.938-81.374l-71.438-71.437c-42.423,17.186-56.225,46.703-69.591,75.289        C83.571,283.8,72.167,308.192,44.421,319.527z" />
                              </g>

                              <g>
                                <path d="M367.369,383.774c-2.56,0-5.118-0.977-7.071-2.929L232.156,252.704c-3.905-3.905-3.905-10.237,0-14.143        s10.237-3.905,14.143,0L374.44,366.703c3.905,3.905,3.905,10.237,0,14.143C372.487,382.798,369.929,383.774,367.369,383.774z" />
                              </g>

                              <g>
                                <path d="M130.864,299.741c-2.559,0-5.118-0.977-7.071-2.929l-40.408-40.407c-3.905-3.905-3.906-10.237,0-14.142        s10.237-3.906,14.142,0l40.408,40.407c3.905,3.905,3.906,10.237,0,14.143C135.982,298.765,133.423,299.741,130.864,299.741z" />
                              </g>
                            </g>

                            <g>
                              <g>
                                <path d="M450.209,224.289c-17.424,0-34.063-6.037-50.395-11.961c-30.989-11.242-63.031-22.867-108.16-1.462        c-4.991,2.367-10.954,0.24-13.32-4.75c-2.367-4.99-0.24-10.954,4.75-13.321c52.671-24.982,91.974-10.725,123.551,0.732        c27.715,10.054,49.606,17.996,74.976,0.127c4.518-3.181,10.755-2.097,13.935,2.417c3.18,4.515,2.098,10.754-2.417,13.934        C478.181,220.533,463.951,224.289,450.209,224.289z" />
                              </g>

                              <g>
                                <path d="M450.209,194.149c-17.424,0-34.063-6.037-50.395-11.961c-30.988-11.243-63.034-22.867-108.16-1.462        c-4.991,2.367-10.953,0.24-13.32-4.75c-2.367-4.99-0.24-10.954,4.75-13.321c52.673-24.983,91.973-10.724,123.551,0.732        c27.717,10.054,49.609,17.995,74.976,0.127c4.518-3.18,10.755-2.098,13.935,2.417s2.098,10.754-2.417,13.934        C478.181,190.393,463.951,194.149,450.209,194.149z" />
                              </g>

                              <g>
                                <path d="M450.21,164.148c-17.425,0-34.064-6.037-50.396-11.961c-1.924-0.698-3.861-1.401-5.816-2.101        c-5.2-1.861-7.906-7.585-6.045-12.785s7.59-7.904,12.785-6.045c1.981,0.709,3.946,1.422,5.896,2.129        c27.715,10.055,49.606,17.996,74.976,0.128c4.518-3.18,10.755-2.098,13.935,2.417s2.098,10.753-2.417,13.934        C478.182,160.393,463.951,164.148,450.21,164.148z" />
                              </g>

                              <g>
                                <path
                                  d="M449.628,255.559c-17.014,0-32.934-5.606-49.788-11.542c-18.017-6.345-36.646-12.906-58.003-12.906        c-16.578,0-32.993,3.963-50.183,12.116c-3.099,1.47-6.734,1.249-9.631-0.583c-2.897-1.833-4.654-5.023-4.654-8.452V111.69        c0-3.863,2.225-7.38,5.715-9.035c19.712-9.35,38.718-13.895,58.104-13.895c25.132,0,46.551,7.771,65.448,14.626        c15.316,5.557,29.783,10.805,43.479,10.805c11.145,0,21.152-3.393,31.495-10.678c3.053-2.149,7.049-2.42,10.364-0.701        c3.314,1.72,5.395,5.143,5.395,8.876v121.219c0,3.253-1.582,6.303-4.241,8.176C479.3,250.824,465.071,255.559,449.628,255.559        z M341.837,211.111c24.775,0,45.958,7.46,64.646,14.042c15.196,5.352,29.549,10.406,43.145,10.406        c9.801,0,18.727-2.572,27.741-8.043v-98.814c-8.755,3.682-17.775,5.491-27.254,5.491c-17.211,0-33.283-5.831-50.3-12.004        c-18.195-6.601-37.012-13.427-58.627-13.427c-14.512,0-28.903,3.081-43.819,9.398v101.012        C312.287,213.759,326.95,211.111,341.837,211.111z"
                                />
                              </g>

                              <g>
                                <path d="M287.369,423.152c-5.522,0-10-4.478-10-10V231.934c0-5.523,4.478-10,10-10s10,4.477,10,10v181.219        C297.369,418.675,292.892,423.152,287.369,423.152z" />
                              </g>

                              <g>
                                <path d="M395.184,178.757c-5.522,0-10-4.477-10-10v-57.146c0-5.523,4.478-10,10-10s10,4.477,10,10v57.146        C405.184,174.28,400.706,178.757,395.184,178.757z" />
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>

                    <g id="Layer_1" />
                  </svg>
                  <input name="pays" id="pays" v-model="formulaire.pays" type="text" class="form-input pl-11" placeholder="Pays :" />
                </div>
              </div>

              <div class="form-icon relative mt-2">
                <label for="nom" class="mb-2">Ville</label>
                <div class="form-icon relative mt-2">
                  <svg class="w-4 h-4 absolute top-2 left-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                    <!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                    <path
                      d="M480 48c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48V96H224V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V96H112V24c0-13.3-10.7-24-24-24S64 10.7 64 24V96H48C21.5 96 0 117.5 0 144v96V464c0 26.5 21.5 48 48 48H304h32 96H592c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H480V48zm96 320v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM240 416H208c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zM128 400c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zM560 256c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32zM256 176v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM112 160c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32zM256 304c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zM112 320H80c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zm304-48v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM400 64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32zm16 112v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"
                    />
                  </svg>
                  <!-- <i class="uil uil-envelope w-4 h-4 absolute top-2 left-4"></i> -->
                  <input name="Ville" id="Ville" v-model="formulaire.ville" type="text" class="form-input pl-11" placeholder="Ville :" />
                </div>
              </div>
            </div>

            <div class="w-full md:w-1/2 space-y-2">
              <div class="form-icon relative mt-2">
                <label for="nom" class="mb-2">Prénom</label>
                <div class="form-icon relative mt-2">
                  <svg class="w-4 h-4 absolute top-2 left-4" width="800px" height="800px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <title>text_style [#1212]</title>
                    <desc>Created with Sketch.</desc>
                    <defs></defs>
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="Dribbble-Light-Preview" transform="translate(-60.000000, -2759.000000)" fill="#000000">
                        <g id="icons" transform="translate(56.000000, 160.000000)">
                          <path d="M24,2599 L24,2605 L22,2605 C22,2602.791 20.209,2601 18,2601 L16.586,2601 C15.71,2601 15,2601.71 15,2602.586 L15,2616 C15,2616.552 15.448,2617 16,2617 L18,2617 L18,2619 L10,2619 L10,2617 L12,2617 C12.552,2617 13,2616.552 13,2616 L13,2602.586 C13,2601.71 12.29,2601 11.414,2601 L10,2601 C7.791,2601 6,2602.791 6,2605 L4,2605 L4,2599 L24,2599 Z" id="text_style-[#1212]"></path>
                        </g>
                      </g>
                    </g>
                  </svg>
                  <input name="prenom" id="prenom" v-model="formulaire.prenoms" type="text" class="form-input pl-11" placeholder="Prénom :" />
                </div>
              </div>

              <div class="form-icon relative mt-2">
                <label for="nom" class="mb-2">Conctact de votre Entreprise</label>
                <div class="form-icon relative mt-2">
                  <i class="uil uil-calling w-4 h-4 absolute top-2 left-4"></i>
                  <input name="Conctact" id="Conctact" v-model="formulaire.entrepriseContact" type="number" class="form-input pl-11" placeholder="Conctact de votre Entreprise :" />
                </div>
              </div>

              <div class="form-icon relative mt-2">
                <label for="nom" class="mb-2">Domaine</label>
                <div class="form-icon relative mt-2">
                  <svg class="w-4 h-4 absolute top-2 left-4" width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 16.0156C19.2447 16.5445 20 17.2392 20 18C20 19.6568 16.4183 21 12 21C7.58172 21 4 19.6568 4 18C4 17.2392 4.75527 16.5445 6 16.0156" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                    <path d="M17 8.44444C17 11.5372 12 17 12 17C12 17 7 11.5372 7 8.44444C7 5.35165 9.23858 3 12 3C14.7614 3 17 5.35165 17 8.44444Z" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                    <circle cx="12" cy="8" r="1" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                  </svg>
                  <i class="uil uil-envelope w-4 h-4 absolute top-2 left-4"></i>
                  <input name="domaine" id="domaine" v-model="formulaire.domaine" type="text" class="form-input pl-11" placeholder="Domaine :" />
                </div>
              </div>
              <div class="form-icon relative mt-2">
                <label for="nom" class="mb-2">Arrondissement</label>
                <div class="form-icon relative mt-2">
                  <svg class="w-4 h-4 absolute top-2 left-4" fill="#000000" height="800px" width="800px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve">
                    <g>
                      <g>
                        <path
                          d="M500.121,234.023h-24.947v-48.705c0-6.561-5.32-11.879-11.879-11.879h-36.826V137.75c0-6.561-5.189-11.829-11.75-11.829
  			h-36.955V96.222c0-6.561-5.32-11.879-11.879-11.879c-6.56,0-11.879,5.318-11.879,11.879v29.698h-40.39V29.698
  			c0-6.561-4.86-11.879-11.42-11.879h-80.19c-6.561,0-11.74,5.32-11.74,11.879V62.96h-68.45c-6.561,0-12.33,5.639-12.33,12.2v62.64
  			h-17.819v-5.94c0-6.561-5.32-11.879-11.879-11.879c-6.56,0-11.879,5.318-11.879,11.879v5.94H61.773
  			c-6.56,0-11.879,5.318-11.879,11.879v89.095H11.879C5.32,238.774,0,244.093,0,250.654s5.32,11.879,11.879,11.879h23.843
  			c12.147-22.355,26.85-34.129,42.715-34.129c3.729,0,7.394,0.652,10.975,1.938c1.063-2.46,2.179-4.874,3.344-7.217
  			c12.581-25.301,28.169-38.674,45.076-38.674c16.907,0,32.495,13.374,45.076,38.674c1.292,2.598,2.518,5.289,3.684,8.028
  			c4.227-1.818,8.573-2.749,13.013-2.749c3.729,0,7.394,0.652,10.975,1.938c1.063-2.46,2.179-4.874,3.344-7.217
  			c12.581-25.301,28.17-38.674,45.076-38.674s32.495,13.374,45.076,38.674c1.293,2.598,2.518,5.289,3.684,8.028
  			c4.227-1.818,8.573-2.749,13.013-2.749c3.729,0,7.394,0.652,10.975,1.938c1.063-2.46,2.179-4.874,3.344-7.217
  			c12.581-25.301,28.169-38.674,45.076-38.674c16.907,0,32.495,13.374,45.076,38.674c1.292,2.598,2.518,5.289,3.684,8.028
  			c4.227-1.818,8.573-2.749,13.013-2.749c14.698,0,28.399,10.113,39.994,29.378h18.185c6.56,0,11.879-5.318,11.879-11.879
  			C512,239.341,506.68,234.023,500.121,234.023z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M137.834,208.209c-9.479,0-21.098,17.205-28.718,36.58c5.125,5.899,9.95,13.345,14.398,22.289
  			c7.958,16.002,13.661,35.284,15.126,50.401c0.255-0.006,0.512-0.008,0.766-0.019c1.467-15.114,7.17-34.386,15.124-50.38
  			c3.974-7.991,8.247-14.787,12.767-20.353C159.704,226.577,147.627,208.209,137.834,208.209z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M259.003,208.209c-9.479,0-21.098,17.205-28.718,36.58c5.125,5.899,9.95,13.345,14.398,22.289
  			c7.958,16.002,13.661,35.284,15.126,50.401c0.255-0.006,0.512-0.008,0.766-0.019c1.467-15.114,7.17-34.386,15.124-50.38
  			c3.974-7.991,8.247-14.787,12.767-20.353C280.873,226.577,268.796,208.209,259.003,208.209z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M380.171,208.209c-9.479,0-21.098,17.205-28.718,36.58c5.125,5.899,9.95,13.345,14.398,22.289
  			c7.958,16.002,13.661,35.284,15.126,50.401c0.255-0.006,0.512-0.008,0.766-0.019c1.467-15.114,7.17-34.386,15.124-50.38
  			c3.974-7.99,8.247-14.787,12.767-20.352C402.042,226.577,389.965,208.209,380.171,208.209z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M454.547,437.888c-20.68-1.184-41.283-1.51-61.234-0.971c-9.837,0.266-17.597,8.457-17.331,18.294
  			c0.261,9.675,8.185,17.338,17.802,17.338c0.164,0,0.327-0.002,0.491-0.006c18.961-0.516,38.551-0.202,58.234,0.925
  			c0.347,0.02,0.691,0.03,1.035,0.03c9.375,0,17.231-7.324,17.774-16.802C471.881,446.871,464.371,438.451,454.547,437.888z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M360.996,456.283c-1.013-9.787-9.791-16.902-19.559-15.886c-7.337,0.76-14.837,1.635-22.933,2.674
  			c-9.761,1.254-16.657,10.183-15.404,19.944c1.156,8.99,8.822,15.55,17.651,15.55c0.757,0,1.522-0.049,2.293-0.147
  			c7.804-1.003,15.023-1.845,22.065-2.574C354.897,474.829,362.011,466.071,360.996,456.283z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M285.276,465.763c-1.422-9.738-10.465-16.476-20.208-15.06c-25.122,3.669-51.86,7.288-78.254,7.718
  			c-30.214,0.494-58.276-0.513-83.419-2.99c-9.804-0.96-18.515,6.193-19.48,15.987c-0.965,9.795,6.193,18.515,15.986,19.48
  			c22.164,2.183,46.387,3.283,72.192,3.283c5.04,0,10.144-0.042,15.301-0.126c28.513-0.464,56.55-4.249,82.825-8.086
  			C279.956,484.547,286.697,475.5,285.276,465.763z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M463.937,385.021c-3.899-0.271-7.792-0.501-11.681-0.712c-0.28,0.049-0.558,0.106-0.841,0.151v-24.248
  			c15.731-4.191,27.355-18.553,27.355-35.586c0-26.237-21.289-72.464-36.826-72.464c-15.537,0-36.826,46.227-36.826,72.464
  			c0,15.242,9.307,28.35,22.539,33.94v24.926c-0.178-0.043-0.36-0.08-0.538-0.125c-11.398-0.234-22.693-0.209-33.806,0.091
  			c-22.451,0.607-43.236,2.394-63.066,4.71v-3.705v-24.254c15.731-4.191,27.355-18.553,27.355-35.586
  			c0-26.237-21.289-72.464-36.826-72.464c-15.537,0-36.826,46.227-36.826,72.464c0,15.242,9.307,28.35,22.539,33.94v24.926v7.723
  			c-9.776,1.351-19.38,2.771-28.892,4.18c-23.614,3.501-46.246,6.856-68.519,8.52v-19.452v-24.254
  			c15.731-4.191,27.355-18.553,27.355-35.586c0-26.237-21.289-72.464-36.826-72.464s-36.826,46.227-36.826,72.464
  			c0,15.242,9.307,28.35,22.539,33.94v24.926v21.486c-36.315,0.535-68.906-1.062-97.411-4.753v-15.761v-24.254
  			c15.731-4.191,27.355-18.553,27.355-35.586c0-26.237-21.289-72.464-36.826-72.464S41.61,298.385,41.61,324.622
  			c0,15.242,9.307,28.35,22.539,33.94v24.926v12.998c-5.211-0.979-10.268-2.036-15.141-3.181
  			c-9.58-2.254-19.171,3.689-21.422,13.269c-2.251,9.581,3.689,19.172,13.269,21.423c35.959,8.452,79.971,12.722,131.017,12.722
  			c5.102,0,10.279-0.043,15.522-0.128c31.833-0.519,62.724-5.099,95.428-9.947c34.689-5.143,70.56-10.46,111.453-11.565
  			c21.851-0.59,44.456-0.088,67.19,1.493c9.81,0.675,18.331-6.721,19.013-16.54C481.16,394.216,473.754,385.704,463.937,385.021z"
                        />
                      </g>
                    </g>
                  </svg>
                  <input name="Arrondissement" id="Arrondissement" v-model="formulaire.arrondissement" type="text" class="form-input pl-11" placeholder="Arrondissement :" />
                </div>
              </div>

              <div class="form-icon relative mt-2">
                <label for="nom" class="mb-2">Boite postale</label>
                <div class="form-icon relative mt-2">
                  <svg class="w-4 h-4 absolute top-2 left-4" fill="#000000" height="800px" width="800px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 465 465" xml:space="preserve">
                    <g>
                      <path
                        d="M337.5,110h-56.464c-4.142,0-7.5,3.357-7.5,7.5s3.358,7.5,7.5,7.5H337.5c43.541,0,78.964,35.423,78.964,78.964v137.021
        		h-195V203.964c0-33.077-17.182-62.215-43.088-78.964h42.659c4.142,0,7.5-3.357,7.5-7.5s-3.358-7.5-7.5-7.5H127.5
        		c-51.812,0-93.964,42.152-93.964,93.964v144.521c0,4.143,3.358,7.5,7.5,7.5h165.429V457.5c0,4.143,3.358,7.5,7.5,7.5
        		s7.5-3.357,7.5-7.5V355.985h22.071V457.5c0,4.143,3.358,7.5,7.5,7.5s7.5-3.357,7.5-7.5V355.985h165.429c4.142,0,7.5-3.357,7.5-7.5
        		V203.964C431.464,152.152,389.312,110,337.5,110z M48.536,203.964C48.536,160.423,83.959,125,127.5,125
        		s78.964,35.423,78.964,78.964v137.021H48.536V203.964z"
                      />
                      <path
                        d="M251.036,283.725c4.142,0,7.5-3.357,7.5-7.5V73h67.695c9.098,0,16.5-7.402,16.5-16.5v-40c0-9.098-7.402-16.5-16.5-16.5
        		h-75.195c-4.142,0-7.5,3.357-7.5,7.5v268.725C243.536,280.367,246.894,283.725,251.036,283.725z M327.73,16.5v40
        		c0,0.827-0.673,1.5-1.5,1.5h-67.695V15h67.695C327.058,15,327.73,15.673,327.73,16.5z"
                      />
                      <path
                        d="M127.5,160c-4.142,0-7.5,3.357-7.5,7.5v23c0,4.143,3.358,7.5,7.5,7.5s7.5-3.357,7.5-7.5v-23
        		C135,163.357,131.642,160,127.5,160z"
                      />
                    </g>
                  </svg>
                  <input name="nombre" id="nombre" v-model="formulaire.boitePostale" type="text" class="form-input pl-11" placeholder="boite postale :" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-end px-6">
        <button v-if="grizer" type="button" id="submitNumber" name="Payment Number" class="btn float-right bg-bsd-700 border-indigo-200 hover:border-indigo-700 text-white rounded-md ml-3 mb-6 text-sm font-semibold uppercase pointer-events-none opacity-25">Payer</button>
        <button v-else type="button" @click="showPayement()" class="btn bg-bsd-700 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md ml-3 mb-6 text-sm font-semibold uppercase">Payer</button>
      </div>
    </div>

    <!-- paiement -->
    <div class="rounded-md shadow dark:shadow-gray-800 bg-white dark:bg-slate-900 mt-16" v-if="afficherPayement">
      <div class="p-6 md:flex justify-between items-center border-b border-gray-100 dark:border-gray-700">
        <div class="mb-4 md:mb-0">
          <h5 class="text-xl md:text-3xl font-bold uppercase">3. Paiement</h5>
          <p class="text-slate-400 mt-2">Sélectionnez le moyen de paiement qui vous convient et procéder à la validation de votre commande.</p>
        </div>
      </div>
      <div class="p-6">
        <div class="relative flex flex-col lg:flex-row gap-[30px]">
          <div class="w-1/4 _px-6">
            <ul>
              <li class="flex justify-between items-center py-6 border-t border-gray-100 dark:border-gray-700">
                <div class="flex items-center">
                  <img src="../assets/images/payments/mtnmomolatest.svg" class="rounded shadow dark:shadow-gray-800 w-12" alt="" />

                  <div class="ml-3">
                    <p class="font-semibold">MTN MOBILE MONEY - MOOV MONEY</p>
                    <p class="text-slate-400 text-sm">Bénin / Togo/ Côte d’ivoire</p>
                  </div>
                </div>
                <button @click="selectedPayment" :class="{ 'text-selected': selectedText }" type="checkbox"><i :class="{ 'uil-check-circle': isActive }" class="uil text-indigo-600 text-2xl font-bold mr-2"></i></button>
              </li>
            </ul>
          </div>
          <div class="w-full">
            <!-- information nombre de kit -->
            <div class="p-6 rounded-md shadow dark:shadow-gray-800 bg-white dark:bg-slate-900 mt-4">
              <h5 class="text-lg font-semibold mb-4">Nombre de kit souhaité :</h5>
              <form @submit.prevent="saveInfo()">
                <div class="grid lg:grid-cols-1 grid-cols-1 gap-5">
                  <div>
                    <div class="form-icon relative mt-2">
                      <i class="uil uil-ruler w-4 h-4 absolute top-2 left-4"></i>
                      <input name="name" id="occupation" min="1" max="100" v-model="formulaire.nbre" type="number" class="form-input pl-12" placeholder="Entré la quantité souhaiter" />
                    </div>
                  </div>
                </div>
                <!--end grid-->
              </form>
              <!--end form-->
            </div>

            <div class="relative overflow-x-auto shadow dark:shadow-gray-800 rounded-md mt-6">
              <table class="w-full text-left text-slate-500 dark:text-slate-400">
                <thead class="text-sm uppercase bg-slate-50 dark:bg-slate-800">
                  <tr>
                    <th scope="col" class="px-6 py-3 w-16">No.</th>
                    <th scope="col" class="px-6 py-3">Désignation</th>
                    <th scope="col" class="px-6 py-3">Quantité</th>
                    <th scope="col" class="px-6 py-3 w-20">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="bg-white dark:bg-slate-900">
                    <td class="px-6 py-4 text-center">1</td>
                    <th scope="row" class="px-6 py-4 font-medium text-gray-900 dark:text-white whitespace-nowrap">
                      {{ grille.type }}
                    </th>
                    <th scope="row" class="px-6 py-4 font-medium text-gray-900 dark:text-white whitespace-nowrap">
                      {{ formulaire.nbre }}
                    </th>

                    <td v-if="grille.promotion?.pourcentage !== 0" class="px-6 py-4 whitespace-nowrap">{{ formulaire.nbre * grille.prix * (1 - grille.promotion?.pourcentage / 100) }} XOF</td>
                    <td v-else class="px-6 py-4 whitespace-nowrap">{{ formulaire.nbre * grille.prix }} XOF</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- information numero de payement -->
            <div class="p-6 rounded-md shadow dark:shadow-gray-800 bg-white dark:bg-slate-900 mt-4">
              <h5 class="text-lg font-semibold mb-4">Numéro de paiement :</h5>
              <form @submit.prevent="saveInfo()">
                <div class="grid lg:grid-cols-1 grid-cols-1 gap-5">
                  <div>
                    <div class="form-icon relative mt-2">
                      <i class="uil uil-phone -4 h-4 absolute top-2 left-4"></i>
                      <input name="name" id="occupation" v-model="formulaire.contact" type="number" class="form-input pl-12" placeholder="+229 000 000 00" />
                    </div>
                  </div>
                </div>
                <!--end grid-->

                <button type="submit" id="submitNumber" name="Payment Number" class="btn bg-gray-700 text-black hover:border-indigo-700 rounded-md mt-5 mr-3">
                  <span
                    class="text-sm font-semibold uppercase"
                    @click="
                      afficherInfoPersonnel = true;
                      afficherPayement = false;
                    "
                  >
                    Retour
                  </span>
                </button>

                <button type="submit" id="submitNumber" name="Payment Number" class="btn bg-bsd-700 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md mt-5">
                  <span class="text-sm font-semibold uppercase" v-if="!chargement"> Éffectuez le paiement </span>
                  <span v-else class="flex justify-center items-center space-x-2">
                    <span class="px-4 font-semibold"> chargement ... </span>
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 text-center animate-spin" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                    </svg>
                  </span>
                </button>
              </form>
              <!--end form-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PackCardComponent from "./PackCardComponent.vue";
import PackService from "@/services/modules/pack.service";
import SouscriptionService from "@/services/modules/souscription.service";
import GrillePackCardComponent from "./GrillePackCardComponent .vue";

export default {
  components: { PackCardComponent, GrillePackCardComponent },
  name: "",
  data() {
    return {
      selectedPlan: "QR Link",
      periodPlan: 7,
      Monthy: {
        month: "mois",
        year: "année",
      },
      totalKit: 3,
      isActive: true,
      selectedText: true,
      grilleId: "",

      grille: {},
      contact: Number,
      formulaire: {
        email: "",
        nom: "",
        prenoms: "",
        entrepriseNom: "",
        entrepriseContact: "",
        pays: "",
        ville: "",
        arrondissement: "",
        domaine: "",
        grilleTarifaireId: "",
        nbre: "1",
        contact: "",
        boitePostale: "",
      },
      idPayement: "",
      infoPayement: {
        nom: "",
        nombre: "",
        montant: "",
        description: "",
        id: "",
      },
      payModalPreview: false,
      chargement2: false,
      chargement: false,
      messages: {
        type: "",
        message: "",
      },
      notification: false,
      scrollHeight: "",
      confirmPassword: "",
      showError: false,
      afficherMp: true,
      afficherMp2: true,
      type: "password",
      type2: "password",
      afficherPayement: false,
      afficherInfoPersonnel: true,
      grizer: true,
      detailGrille: true,
    };
  },

  beforeMount() {
    this.grilleId = this.$route.params.id;
  },
  mounted() {
    this.getGrilleSelected();

    if (localStorage.getItem("formulaire")) {
      this.formulaire = JSON.parse(localStorage.getItem("formulaire"));
    }
  },

  methods: {
    selectedPayment() {
      this.isActive = !this.isActive;
      this.selectedText = !this.selectedText;
    },
    validateValue() {
      // S'assurer que la valeur est toujours supérieure ou égale à 1
      if (this.formulaire.nbre < 1) {
        this.formulaire.nbre = 1;
      }
    },
    showPayement() {
      localStorage.setItem("formulaire", JSON.stringify(this.formulaire));
      this.afficherPayement = true;
      this.afficherInfoPersonnel = false;
      this.detailGrille = false;
    },

    showPassword() {
      this.afficherMp = !this.afficherMp;

      if (this.afficherMp) {
        this.type = "password";
      } else {
        this.type = "text";
      }
    },
    showPassword2() {
      this.afficherMp2 = !this.afficherMp2;

      if (this.afficherMp2) {
        this.type2 = "password";
      } else {
        this.type2 = "text";
      }
    },

    getGrilleSelected() {
      PackService.getOneGrille(this.grilleId)
        .then((response) => {
          let selected = response.data.data;

          this.grille = selected;
        })
        .catch((e) => {});
    },

    saveInfo() {
      localStorage.setItem("formulaire", JSON.stringify(this.formulaire));
      this.validateValue();
      this.scrollHeight = document.getElementById("myDIV").scrollHeight;

      this.formulaire.grilleTarifaireId = this.grilleId;

      if (this.chargement == false) {
        this.chargement = true;
        window.scrollTo({
          top: this.scrollHeight / 2.5,
          behavior: "smooth",
        });
        document.getElementById("myDIV").style.overflow = "hidden";

        SouscriptionService.create(this.formulaire)
          .then((reponse) => {
            this.chargement = false;
            localStorage.removeItem("formulaire");
            this.formulaire = {};
            document.getElementById("myDIV").style.overflow = "scroll";

            let info = reponse.data.data;

            this.successNotificationToggles(reponse.data.statut, reponse.data.message);

            window.location.href = "https://dashboard.bsdfeedback.com/";
          })
          .catch((error) => {
            this.chargement = false;
            document.getElementById("myDIV").style.overflow = "scroll";

            this.successNotificationToggles(error.response.data.statut, error.response.data.message);
          });
      }
    },

    payPack() {
      SouscriptionService.pay(this.infoPayement.id)
        .then((response) => {})
        .catch((e) => {});
    },

    successNotificationToggles(statut, message) {
      this.messages.type = statut;
      this.messages.message = message;

      this.notification = true;

      setTimeout(() => {
        this.notification = false;
      }, 3000);
    },
  },
  watch: {
    formulaire: {
      deep: true,
      handler(newVal) {
        console.log(newVal);
        if (newVal.nom !== "" && newVal.email !== "" && newVal.entrepriseNom !== "" && newVal.pays !== "" && newVal.ville !== "" && newVal.prenoms !== "" && newVal.entrepriseContact !== "" && newVal.domaine !== "" && newVal.arrondissement !== "" && newVal.boitePostale !== "") {
          this.grizer = false;
        } else {
          this.grizer = true;
        }
      },
    },
  },
};
</script>

<style scoped>
/* .persoBg {
  background-color: rgb(64, 52, 52);
  color: black;
} */

.custom_button {
  background: red;
  border-radius: 6px;
  width: 100%;
  color: white;
  padding: 10px;
  font-weight: bold;
  font-size: 14px;
}

.errorColor {
  color: black;
  font-size: 12px;
}

.input::-webkit-outer-spin-button,
/* .input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
} */

/* Firefox */
/* .input[type="number"] {
    -moz-appearance: textfield;
} */

.bgBlack {
  background-color: rgba(0, 0, 0, 0.438);
}

@media screen and (min-width: 768px) {
  .formulaire {
    flex-direction: row !important;
  }
}
</style>
